import { Injectable, Inject } from '@angular/core';
//import 'rxjs/add/operator/catch';
//import 'rxjs/add/observable/throw';
import {
  CityTownVM,
  RecDocVM,
  InstrumentVM,
  RecDateSearchRowVM,
  GetRecNameSearchQuery,
  RecNameSearchListVM,
  RecAddressSearchListVM,
  GetRecAddressSearchQuery,
  GetRecDateSearchQuery,
  RecDateSearchListVM,
  RecNameSearchRowVM,
  RecAddressSearchRowVM,
  DocCatVM,
  DocTypeVM,
  AlphaSearchListVM,
  GetAlphaSearchQuery,
  GetRecValueSearchQuery
} from '../shared/viewmodels/ISearchService';
import {
  GetRecPlanNameSearchQuery,
  RecPlanNameSearchListVM,

  PlanImgObject,
  PlanRoom2VM,
  PlanRoomVM,
  SearchPlanRoom2ListVM,
  GetRecPlanBPSearchQuery
} from '../shared/viewmodels/ISearchServiceReg';
//import {  } from '../shared/viewmodels/ISearchService';
//import { DocCatVM, DocTypeVM } from '../shared/viewmodels/ISearchService';
//import { RecNameSearchRowVM } from '../shared/viewmodels/ISearchService';
//import { RecAddressSearchRowVM } from '../shared/viewmodels/ISearchService';
import { formatDate, parseDate } from "devextreme/localization";
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders, HttpResponseBase, HttpResponse } from '@angular/common/http';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';


export class Name {
  private _lname: string;
  private _fname: string;

  set LName(value: string) {
    this._lname = value;
  }

  get LName(): string {
    return this._lname;

  }

  set FName(value: string) {
    this._fname = value;
  }

  get FName(): string {
    return this._fname;

  }
}
export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}


@Injectable()
export class RecSearchService {
  myAppUrl: string = "";
  name: Name;

  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;


  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }


  getResults(lname, fname, fromdate, todate, roleid, towns, doctypes) {
    let formatedFromDate = formatDate(fromdate, "shortDate");
    let formatedToDate = formatDate(todate, "shortDate");

    const params = new HttpParams().set('lname', lname).set('fname', fname).set('fromdate', formatedFromDate)
      .set('todate', formatedToDate).set('roleid', roleid).set('towns', towns).set('doctypes', doctypes);
    return this._http.get<RecNameSearchRowVM[]>(this.myAppUrl + 'api/CoreData/RecSearchResults', { params });

  }
  getRecNameSearchResults(search: GetRecNameSearchQuery): Observable<RecNameSearchListVM> {
    let url_ = this.myAppUrl + "api/CoreData/GetRecNameSearchResult";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    return this._http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetRecNameSearchResponse(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetRecNameSearchResponse(<any>response_);
        } catch (e) {
          return <Observable<RecNameSearchListVM>><any>_observableThrow(e);
        }
      } else
        return <Observable<RecNameSearchListVM>><any>_observableThrow(response_);

    }));

  }
  processGetRecNameSearchResponse(response: HttpResponseBase): Observable<RecNameSearchListVM> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    if (status === 200) {
      return this.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = RecNameSearchListVM.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return this.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<RecNameSearchListVM>(<any>null);

  }

  //alpha search section
  getAlphaSearchResults(search: GetAlphaSearchQuery): Observable<AlphaSearchListVM> {
    let url_ = this.myAppUrl + "api/CoreData/GetAlphaSearchList";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);
    console.log('get alpha ' + content_);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    return this._http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAlphaSearchResponse(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAlphaSearchResponse(<any>response_);
        } catch (e) {
          return <Observable<AlphaSearchListVM>><any>_observableThrow(e);
        }
      } else
        return <Observable<AlphaSearchListVM>><any>_observableThrow(response_);

    }));

  }

  //getAlphaSearchResults(lname, fname) {

  //  const params = new HttpParams().set('lname', lname).set('fname', fname);
  //  return this._http.get<AlphaSearchRowVM[]>(this.myAppUrl + 'api/CoreData/GetAlphaSearchList', { params });
  //}


  processGetAlphaSearchResponse(response: HttpResponseBase): Observable<AlphaSearchListVM> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    if (status === 200) {
      return this.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AlphaSearchListVM.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return this.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    var r = _observableOf<AlphaSearchListVM>(<any>null);
    return r;

  }





  blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
      if (!blob) {
        observer.next("");
        observer.complete();
      } else {
        let reader = new FileReader();
        reader.onload = event => {
          observer.next((<any>event.target).result);
          observer.complete();
        };
        reader.readAsText(blob);
      }
    });
  }
  throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
      return _observableThrow(result);
    else
      return _observableThrow(new SwaggerException(message, status, response, headers, null));
  }

  getAddressSearchResults(strtnum, strtname, fromdate, todate, towns, doctypes) {
    let formatedFromDate = formatDate(fromdate, "shortDate");
    let formatedToDate = formatDate(todate, "shortDate");

    const params = new HttpParams().set('strtnum', strtnum).set('strtname', strtname).set('fromdate', formatedFromDate)
      .set('todate', formatedToDate).set('towns', towns).set('doctypes', doctypes);
    return this._http.get<RecAddressSearchRowVM[]>(this.myAppUrl + 'api/CoreData/RecAddressSearchResults', { params });

  }
  getRecAddressSearchResults(search: GetRecAddressSearchQuery): Observable<RecAddressSearchListVM> {
    let url_ = this.myAppUrl + "api/CoreData/GetRecAddressSearchList";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);
    console.log(`Sending ${content_} to GetRecAddressSearchList`);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    return this._http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetRecAddressSearchResponse(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetRecAddressSearchResponse(<any>response_);
        } catch (e) {
          return <Observable<RecAddressSearchListVM>><any>_observableThrow(e);
        }
      } else
        return <Observable<RecAddressSearchListVM>><any>_observableThrow(response_);

    }));

  }
  processGetRecAddressSearchResponse(response: HttpResponseBase): Observable<RecAddressSearchListVM> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    if (status === 200) {
      return this.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = RecAddressSearchListVM.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return this.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<RecAddressSearchListVM>(<any>null);

  }

  getRecValueSearchResults(search: GetRecValueSearchQuery): Observable<RecAddressSearchListVM> {
    let url_ = this.myAppUrl + "api/CoreData/GetRecValueSearchResult";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);
    console.log(`Sending ${content_} to GetRecValueSearchResult`);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    return this._http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetRecAddressSearchResponse(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetRecAddressSearchResponse(<any>response_);
        } catch (e) {
          return <Observable<RecAddressSearchListVM>><any>_observableThrow(e);
        }
      } else
        return <Observable<RecAddressSearchListVM>><any>_observableThrow(response_);

    }));

  }
  getCityTown() {

    return this._http.get<CityTownVM[]>(this.myAppUrl + 'api/CoreData/GetCityTown');
  }

  getDocCategories() {

    return this._http.get<DocCatVM[]>(this.myAppUrl + 'api/CoreData/GetDocCategories');
  }

  getDocTypes() {

    return this._http.get<DocTypeVM[]>(this.myAppUrl + 'api/CoreData/GetDocTypes');
  }

  getInstrument(pBook, pPage, type) {

    let url = this.myAppUrl + 'api/CoreData/GetInstrument?pBook=' + pBook + '&pPage=' + pPage + '&type=' + type;
    return this._http.get<InstrumentVM>(url );
  }

  //getAlphaSearchList(pLName: string, pFName: string) {
  //  console.log('getalphalist ' + pLName);
  //  return this._http.get<AlphaSearchListVM>(this.myAppUrl + 'api/CoreData/GetAlphaSearchList?pLName=' + pLName + "&pFName=" + pFName);
  //}


  //getAlphaSearchList(pLName: string, pFName: string) {
  //  console.log('getalphalist ' + pLName);
    
  //  const params = new HttpParams().set('pLName', pLName).set('pFName', pFName);
  //  return this._http.get<AlphaSearchListVM>(this.myAppUrl + 'api/CoreData/GetAlphaSearchList', { params });

  //}



  getRecDoc(docId: number) {
    console.log('getRecDoc ' + docId);
    return this._http.get<RecDocVM>(this.myAppUrl + 'api/CoreData/GetRecDoc?docId=' + docId);
  }
  getLatestRecording() {
    return this._http.get<InstrumentVM>(this.myAppUrl + 'api/CoreData/GetLatestRecording');
  }
  getNextRecDocBP(book: string, page: string, docType: string) {
    return this._http.get<RecDocVM>(this.myAppUrl + 'api/CoreData/GetNextRecDocBP?book=' + book + '&page=' + page + '&docType=' + docType);
  }

  getNextBP(currentBook: string, currentPage: string, currentImageIndex: number) {
    console.log("recsearchservice - getNextBP - " + currentImageIndex);
    return this._http.get<InstrumentVM>(this.myAppUrl + 'api/CoreData/GetNextBP?book=' + currentBook + '&page=' + currentPage + '&currentImageIndexe=' + currentImageIndex);
  }

  getPrevRecDocBP(book: string, page: string, docType: string) {
    return this._http.get<RecDocVM>(this.myAppUrl + 'api/CoreData/GetPrevRecDocBP?book=' + book + '&page=' + page + '&docType=' + docType);
  }

  getPrevBP(currentBook: string, currentPage: string) {
    return this._http.get<InstrumentVM>(this.myAppUrl + 'api/CoreData/GetPrevBP?book=' + currentBook + '&page=' + currentPage);
  }

  getImageByDocId(docId: number) {
    console.log('GetImageByDocId call in service');
    return this._http.get(this.myAppUrl + 'api/CoreData/GetImageByDocId?docId=' + docId, { responseType: 'text' });
  }

  getImageByBookAndPage(book: string, page: string, currentImageIndex: number, searchType: string) {
    console.log('getImageByBookAndPage');

    return this._http.get(this.myAppUrl + 'api/CoreData/GetImageByBookAndPage?book=' + book + '&page=' + page + '&currentImageIndex=' + currentImageIndex + '&type=' + searchType, { responseType: 'text' });
  }

  getContainingDoc(book: string, page: string, type: string) {
    return this._http.get<InstrumentVM>(this.myAppUrl + 'api/CoreData/GetContainingDoc?book=' + book + '&page=' + page + '&type=' + type);
  }

  getDateSearchResults(fromdate, todate, towns, types) {
    let formatedFromDate = formatDate(fromdate, "shortDate");
    let formatedToDate = formatDate(todate, "shortDate");

    const params = new HttpParams().set('fromdate', formatedFromDate).set('todate', formatedToDate).set('towns', towns).set('doctypes', types);

    return this._http.get<RecDateSearchRowVM[]>(this.myAppUrl + 'api/CoreData/RecDateSearchList', {params});
  }

  getRecDateSearchResults(search: GetRecDateSearchQuery): Observable<RecDateSearchListVM> {
    let url_ = this.myAppUrl + "api/CoreData/GetRecDateSearchList";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);
    console.log(`Sending ${content_} to GetRecDateSearchList`);
    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    return this._http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetRecDateSearchResponse(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetRecDateSearchResponse(<any>response_);
        } catch (e) {
          return <Observable<RecDateSearchListVM>><any>_observableThrow(e);
        }
      } else
        return <Observable<RecDateSearchListVM>><any>_observableThrow(response_);

    }));

  }

  processGetRecDateSearchResponse(response: HttpResponseBase): Observable<RecDateSearchListVM> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    if (status === 200) {
      return this.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = RecDateSearchListVM.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return this.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<RecDateSearchListVM>(<any>null);

  }

  padLeft(text: string, padChar: string, size: number): string {
    return (String(padChar).repeat(size) + text).substr((size * -1), size);
  }

  getTypeCat(docType: string) {
    let ret = false;
    switch (docType) {
      case 'RDM TOWN TAX LIEN':
        ret = true;
        break;
      case 'REL OF LIEN':
        ret = true;
        break;
      case 'ABATEMENT':
        ret = true;
        break;
      case 'PAID PRIOR SALE':
        ret = true;
        break;
      case 'REDEEM TAX SALE':
        ret = true;
        break;
    }
    return ret;
  }

  getCityTaxCode(townName: string, docType: string, recDate: Date) {

    let ret = '0';
    let bk = 0;
    //let cutoff = new Date('1/1/1966');
    switch (townName) {
      case 'ALBANY':
        bk = 1;
        let alcutoff = new Date('9/9/1966');
        if (this.getTypeCat(docType)) {
          let endDate = new Date('7/16/1966');
          if (recDate < endDate) {
            bk = +bk + 200;
          } else if (recDate < alcutoff) {
            bk = +bk + 100;
          } 
        } else if (recDate < alcutoff) {
          bk = +bk + 100;
        }
        break;
      case 'BARTLETT':
        bk = 2;
        let btcutoff = new Date('9/18/1966');
        if (this.getTypeCat(docType)) {
          let endDate = new Date('1/4/1967');
          if (recDate < endDate) {
            bk = +bk + 200;
          } else if (recDate < btcutoff) {
            bk = +bk + 100;
          }
        } else if (recDate < btcutoff) {
          bk = +bk + 100;
        }
        break;
      case 'BAY DISTRICT':

        break;
      case 'BROOKFIELD':
        ret = '3';
        bk = 3;
        let bfcutoff = new Date('7/11/1966');
        if (this.getTypeCat(docType)) {
          let endDate = new Date('7/1/1966');
          if (recDate < endDate) {
            bk = +bk + 200;
          } else if (recDate < bfcutoff) {
            bk = +bk + 100;
          }
        } else if (recDate < bfcutoff) {
          bk = +bk + 100;
        }
        break;
      case 'CHATHAM':
        ret = '4';
        bk = 4;
        let chcutoff = new Date('12/16/1966');
        if (this.getTypeCat(docType)) {
          let endDate = new Date('12/17/1966');
          if (recDate < endDate) {
            bk = +bk + 200;
          } else if (recDate < chcutoff) {
            bk = +bk + 100;
          }
        } else if (recDate < chcutoff) {
          bk = +bk + 100;
        }
        break;
      case 'CONWAY':
        ret = '5';
        bk = 5;
        let cwcutoff = new Date('9/19/1966');
        if (this.getTypeCat(docType)) {
          let endDate = new Date('12/28/1966');
          if (recDate < endDate) {
            bk = +bk + 200;
          } else if (recDate < cwcutoff) {
            bk = +bk + 100;
          }
        } else if (recDate < cwcutoff) {
          bk = +bk + 100;
        }
        break;
      case 'EATON':
        ret = '6';
        bk = 6;
        let etcutoff = new Date('8/22/1966');
        if (this.getTypeCat(docType)) {
          let endDate = new Date('9/26/1966');
          if (recDate < endDate) {
            bk = +bk + 200;
          } else if (recDate < etcutoff) {
            bk = +bk + 100;
          }
        } else if (recDate < etcutoff) {
          bk = +bk + 100;
        }
        break;
      case 'EFFINGHAM':
        ret = '7';
        bk = 7;
        let efcutoff = new Date('6/23/1966');
        if (this.getTypeCat(docType)) {
          let endDate = new Date('11/3/1966');
          if (recDate < endDate) {
            bk = +bk + 200;
          } else if (recDate < efcutoff) {
            bk = +bk + 100;
          }
        } else if (recDate < efcutoff) {
          bk = +bk + 100;
        }
        break;
      case 'FREEDOM':
        ret = '8';
        bk = 8;
        let frcutoff = new Date('12/12/1966');
        if (this.getTypeCat(docType)) {
          let endDate = new Date('12/31/1966');
          if (recDate < endDate) {
            bk = +bk + 200;
          } else if (recDate < frcutoff) {
            bk = +bk + 100;
          }
        } else if (recDate < frcutoff) {
          bk = +bk + 100;
        }
        break;
      case 'HALES LOCATION':
        ret = '9';
        bk = 9;
        let hacutoff = new Date('9/4/1963');
        if (this.getTypeCat(docType)) {
          let endDate = new Date('9/12/1963');
          if (recDate < endDate) {
            bk = +bk + 200;
          } else if (recDate < hacutoff) {
            bk = +bk + 100;
          }
        } else if (recDate < hacutoff) {
          bk = +bk + 100;
        }
        break;
      case 'HARTS LOCATION':
        ret = '10';
        bk = 10;
        let htcutoff = new Date('1/1/1966');
        if (recDate < htcutoff) {
          bk = +bk + 100;
        }
        break;
      case 'JACKSON':
        ret = '11';
        bk = 11;
        let jkcutoff = new Date('12/17/1966');
        if (this.getTypeCat(docType)) {
          let endDate = new Date('12/20/1963');
          if (recDate < endDate) {
            bk = +bk + 200;
          } else if (recDate < jkcutoff) {
            bk = +bk + 100;
          }
        } else if (recDate < jkcutoff) {
          bk = +bk + 100;
        }
        break;
      case 'KEARSARGE LIGHTING':

        break;
      case 'MADISON':
        ret = '12';
        bk = 12;
        let mdcutoff = new Date('8/5/1966');
        if (this.getTypeCat(docType)) {
          let endDate = new Date('8/19/1966');
          if (recDate < endDate) {
            bk = +bk + 200;
          } else if (recDate < mdcutoff) {
            bk = +bk + 100;
          }
        } else if (recDate < mdcutoff) {
          bk = +bk + 100;
        }
        break;
      case 'MOULTONBOROUGH':
        ret = '13';
        bk = 13;
        let mocutoff = new Date('9/2/1966');
        if (this.getTypeCat(docType)) {
          let endDate = new Date('11/12/1966');
          if (recDate < endDate) {
            bk = +bk + 200;
          } else if (recDate < mocutoff) {
            bk = +bk + 100;
          }
        } else if (recDate < mocutoff) {
          bk = +bk + 100;
        }
        break;
      case 'OSSIPEE':
        ret = '14';
        bk = 14;
        let oscutoff = new Date('12/15/1966');
        if (this.getTypeCat(docType)) {
          let endDate = new Date('12/31/1966');
          if (recDate < endDate) {
            bk = +bk + 200;
          } else if (recDate < oscutoff) {
            bk = +bk + 100;
          }
        } else if (recDate < oscutoff) {
          bk = +bk + 100;
        }
        break;
      case 'SANDWICH':
        ret = '15';
        bk = 15;
        let swcutoff = new Date('8/8/1966');
        if (this.getTypeCat(docType)) {
          let endDate = new Date('8/1/1966');
          if (recDate < endDate) {
            bk = +bk + 200;
          } else if (recDate < swcutoff) {
            bk = +bk + 100;
          }
        } else if (recDate < swcutoff) {
          bk = +bk + 100;
        }
        break;
      case 'TAMWORTH':
        ret = '16';
        bk = 16;
        let twcutoff = new Date('7/8/1966');
        if (this.getTypeCat(docType)) {
          let endDate = new Date('10/6/1966');
          if (recDate < endDate) {
            bk = +bk + 200;
          } else if (recDate < twcutoff) {
            bk = +bk + 100;
          }
        } else if (recDate < twcutoff) {
          bk = +bk + 100;
        }
        break;
      case 'TUFTONBORO':
        ret = '17';
        bk = 17;
        let tfcutoff = new Date('8/18/1966');
        if (this.getTypeCat(docType)) {
          let endDate = new Date('7/29/1966');
          if (recDate < endDate) {
            bk = +bk + 200;
          } else if (recDate < tfcutoff) {
            bk = +bk + 100;
          }
        } else if (recDate < tfcutoff) {
          bk = +bk + 100;
        }
        break;
      case 'WAKEFIELD':
        ret = '18';
        bk = 18;
        let wfcutoff = new Date('6/10/1966');
        if (this.getTypeCat(docType)) {
          let endDate = new Date('12/21/1966');
          if (recDate < endDate) {
            bk = +bk + 200;
          } else if (recDate < wfcutoff) {
            bk = +bk + 100;
          }
        } else if (recDate < wfcutoff) {
          bk = +bk + 100;
        }
        break;
      case 'WOLFEBORO':
        ret = '19';
        bk = 19;
        let wbcutoff = new Date('8/12/1966');
        if (this.getTypeCat(docType)) {
          let endDate = new Date('9/28/1966');
          if (recDate < endDate) {
            bk = +bk + 200;
          } else if (recDate < wbcutoff) {
            bk = +bk + 100;
          }
        } else if (recDate < wbcutoff) {
          bk = +bk + 100;
        }
    }
    return bk;
  }

  setExportCost(filteredCount: number) {
    let totalCost = filteredCount * .02;
    totalCost = +totalCost.toFixed(2);
    if (totalCost < 2)
      totalCost = 2;
    return totalCost
  }

  //errorHandler(error: HttpErrorResponse) {
  //  return Observable.throw(error.message || "Server Error");
  //}

  logError(message: string) {
    this._http.get<string>(this.myAppUrl + 'api/CoreData/LogError?message=' + message);
  }

  logInfo(message: string) {
    this._http.get(this.myAppUrl + 'api/CoreData/LogInfo?message=' + message);
  }

  logWarning(message: string) {
    this._http.get<string>(this.myAppUrl + 'api/CoreData/LogWarning?message=' + message);
  }


  GetPlanDoc(book: string, page: number) {
    return this._http.get<PlanRoom2VM>(this.myAppUrl + 'api/ES/GetPlanDoc?book=' + book + '&page=' + page);
  }

  isInPlanFolder(book: string, page: string): boolean {

    if ((+book < 238) || (+book === 238 && +page < 37/*37*/))
      return true;
    else
      return false;
  }
}

